export default __webpack_public_path__ + "static/media/mealPlannerBackground.714454ca.png";